<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <component :is="wrapperComponent" :href="isLink ? href : null" class="group">
    <div class="w-full h-3 bg-orange mt-16 lg:mt-34"></div>
    <paragraph
      v-if="tag"
      :text="tag"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="font-bold text-sm mb-3 lg:mb-5 mt-7"
    />
    <header4
      :text="title"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="mt-7 md:mt-8"
    />
    <rich-text
      v-if="cleanedDescription"
      :text="cleanedDescription"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="mt-3"
    />
    <div v-if="list && list?.length > 0" class="mt-4 md:mt-5 flex flex-col">
      <list-link
        v-for="(link, index) in links"
        :key="index"
        :label="link.ctaLabel"
        :url="link.ctaLink"
        :linkType="link.linkType"
        :target="link.target"
        :themeType="themeType"
        classes="mt-2"
      />
    </div>
    <div v-if="isLink" class="w-6 h-6 mt-4 lg:mt-5">
      <link-svg styles="stroke-aubergine group-hover:stroke-orange" />
    </div>
  </component>
</template>

<script lang="ts" setup>
import Header4 from "@components/Typography/Header4.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import Paragraph from "@components/Typography/Paragraph.ce.vue";
import ListLink from "@atoms/ListLink/ListLink.ce.vue";
import { IListItem } from "@/types/components/IListProps";
import { withDefaults, defineProps, toRefs, computed, ref } from "vue";
import { getThemeType } from "@/util/helper";
import LinkSvg from "@atoms/ListLink/LinkSvg.vue";
const cleanedDescriptionText = ref<string>("");

const props = withDefaults(defineProps<IListItem>(), {
  isUmbraco: false,
});

const { title, description, theme, list, tag, isLink, href } = toRefs(props);

const themeType = computed(() => {
  return getThemeType(theme.value);
});

const links = computed(() => {
  if (!list?.value) return;
  return list.value;
});

const wrapperComponent = computed(() => (isLink.value ? "a" : "div"));

const cleanedDescription = computed(() => {
  if (!description?.value) return;
  cleanedDescriptionText.value = description.value.replace(/\-\->/gm, "");
  if (!cleanedDescriptionText.value) return;
  return cleanedDescriptionText.value;
});
</script>
